import { createAsyncThunk, createEntityAdapter, createSlice, EntityState } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { AppId, AppThunkAPIType } from "../../app/appTypes";
import { getWithAuth, postWithAuth, putWithAuth } from "../../http";

export type CompanyToRegisterId = string;

export interface CompanyToRegister {
    id: CompanyToRegisterId,
    companyName: string,
    companyId: number,
    shortName: string,
    isProducer: boolean,
    isCustomer: boolean,
    address: string,
    address2: string,
    city: string,
    state: string,
    zipcode: string,
    country: string,
    firstName: string,
    surname: string,
    contactPerson: string,
    email: string,
    phone: string,
    mobile: string,
    areas: Array<{areaId: AppId }>,
    objectType: string | null;
    objectId: string | null;
    createDate: Date
}

export interface CompanyToRegisterPayload {
    option: string;
    email: string;
    firstName: string;
    lastName: string;
    phone: string;
    address: string;
    companyName: string;
    city: string;
    state: string;
    zipcode: string;
    country: string;
}

export interface ContactPerson {
    firstName: string,
    surname: string,
    email: string,
    phone: string
}

export type DraftCompany = Omit<CompanyToRegister, "id">

export const loadCompaniesToRegister = createAsyncThunk<CompanyToRegister[], void, AppThunkAPIType>(
    "companies-to-register/load",
    async (_, { dispatch, rejectWithValue, requestId, getState }) => {

        const result = await dispatch(getWithAuth({ url: `api/companies-to-register` }))
        const { payload } = result
                if (getWithAuth.fulfilled.match(result)) {
            return payload as CompanyToRegister[]
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    }
)

export const loadCompanyToRegister = createAsyncThunk<CompanyToRegister, CompanyToRegisterId, AppThunkAPIType>(
    "company-to-register/load",
    async (companyId, { dispatch, rejectWithValue, requestId, getState }) => {

        const result = await dispatch(getWithAuth({ url: `api/companies-to-register/${companyId}` }))
        const { payload } = result
                if (getWithAuth.fulfilled.match(result)) {
            return payload as CompanyToRegister
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    }
)

export const createCompanyToRegister = createAsyncThunk<CompanyToRegister, CompanyToRegisterPayload, AppThunkAPIType>
    ("companies/create", async (company, { dispatch, rejectWithValue }) => {
        const result = await dispatch(postWithAuth({ 
            url: `api/companies-to-register`,
            payload: company,
        }))
        const { payload } = result
        if (postWithAuth.fulfilled.match(result)) {
            return payload as CompanyToRegister
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    }
)

export const updateCompanyToRegister = createAsyncThunk<CompanyToRegister, CompanyToRegisterPayload & { id: string }, AppThunkAPIType>
    ("companies/update", async (company, { dispatch, rejectWithValue }) => {
        const result = await dispatch(putWithAuth({ 
            url: `api/companies-to-register/${company.id}`,
            payload: company,
        }))
        const { payload } = result
        if (postWithAuth.fulfilled.match(result)) {
            return payload as CompanyToRegister
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    }
)